import { render, staticRenderFns } from "./form-errors.vue?vue&type=template&id=6d760aaf"
import script from "./form-errors.vue?vue&type=script&lang=js"
export * from "./form-errors.vue?vue&type=script&lang=js"
import style0 from "./form-errors.vue?vue&type=style&index=0&id=6d760aaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports